import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SaveFilterCriteria } from '../models/save-filter-criteria.model';
import { SavedFilterType } from '../models/saved-filter-type.model';
import { SavedFilters } from '../models/saved-filters.model';
import { SAVED_FILTERS_API_BASE_URL } from '../saved-filters.const';

@Injectable({ providedIn: 'root' })
export class SavedFiltersRepository {
  constructor(private http: HttpClient) {}

  getSavedFilters(filterType: SavedFilterType): Observable<SavedFilters> {
    return this.http.get<SavedFilters>(`${SAVED_FILTERS_API_BASE_URL}/names?type=${filterType}`);
  }

  deleteSavedFilter(filterId: number): Observable<void> {
    return this.http.delete<void>(`${SAVED_FILTERS_API_BASE_URL}/${filterId}`);
  }

  getSavedFilterCriteriaById(id: number): Observable<SaveFilterCriteria> {
    return this.http.get<SaveFilterCriteria>(`${SAVED_FILTERS_API_BASE_URL}/${id}`);
  }
}
